import { Component, OnInit } from '@angular/core';
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import { OffersService } from '../../../../shared/services/admServices/offers.service';
import { BlackListDelete, IblackListOffer, Page, PageClass } from '../../../../shared/filters/filters';

declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'adm-black-component',
  templateUrl: './black-component.html',
  styleUrls: ['./black-component.scss'],
})
export class offerblacklistComponent implements OnInit {

  dropdownListAdvertiser: any[] = [];
  selectedItemsAdvertiser : any[] = [];
  dropdownSettingsAdvertiser: any = {};

  page = new Page();
  sendpage = new PageClass();
  pageSizeDefinition = 10;
  errorMessage = '';

  blackListOffer : IblackListOffer = { publisherId:0, advertiserId:0, advertiserOfferId:"" };
  blacklistData: any;
  blackListOfferDelete = new BlackListDelete();
  rows : any[] = [];
  public selected : any[] = [];

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  constructor(private toastrService: ToastrService, private offersService: OffersService) {
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;
  }

  ngOnInit(): void {

     // dropdownlist ADVERTISER
     this.dropdownListAdvertiser = [
      { item_id: 1, item_text: 'AdGate' },
      { item_id: 2, item_text: 'Affluent' },
      { item_id: 3, item_text: 'Aragon' },
      { item_id: 4, item_text: 'ClickDealer' },
      { item_id: 5, item_text: 'Mapstreet' },
      { item_id: 6, item_text: 'PocketMedia' },
      { item_id: 7, item_text: 'SmartResponseMedia' },  //
      { item_id: 8, item_text: 'Vanelo' },  //
      { item_id: 9, item_text: 'OpinionSample' },
      { item_id: 10, item_text: 'Wdigital' },
      { item_id: 11, item_text: 'AdstartMedia' },
      { item_id: 12, item_text: 'Mobitka' } //
    ];
    this.dropdownSettingsAdvertiser = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: false,
      closeDropDownOnSelection: true
    };

    this.setPage({ offset: 0 });
  }

  setPage(pageInfo){
    this.sendpage.pageNumber = pageInfo.offset+1;
    this.sendpage.pageSize = this.pageSizeDefinition;

    this.offersService.getBlackList(this.sendpage)
      .subscribe(
      data => {
        this.page.totalElements = data.totalRecords;
        this.page.totalPages = data.totalPages;
        this.page.pageNumber = data.pageNumber-1;
        this.blacklistData = data.data;
      },
      error => {
        console.log(error);
      });
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    if(selected.length!=0)
    {
      this.blackListOfferDelete.deleteId = [];
      for(let i=0;i<selected.length;i++)
        this.blackListOfferDelete.deleteId[i] = selected[i].id;
    }
    else
      this.blackListOfferDelete.deleteId = [];
  }

  onAdd() {
    if(this.blackListOffer.advertiserId==0)
      this.toastrService.error('Select Advertiser', 'Error !');
    else
    {
      this.offersService.addBlackList(this.blackListOffer).subscribe(
        response => {
          this.toastrService.success('Added Publisher on black list .', 'Success !');
          this.setPage({ offset: 0 });
        },
        err => {
          console.log(err);
          this.errorMessage = err.error.errors[0].message;
          this.toastrService.error(`${this.errorMessage}`, 'Error !');
      });
    }
  }

  onDelete(){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {

        this.offersService.deleteBlackList(this.selected[0].id)
        .subscribe(
          response => {
            console.log(response);
            Swal.fire(
              'Deleted!',
              'Your black list record(s) has been deleted.',
              'success'
            )
            this.setPage({ offset: 0 });
          },
          error => {
            console.log(error);
          });
      }
    })
  }

  onItemSelectAdvertiser(item: any) {
    this.blackListOffer.advertiserId = this.selectedItemsAdvertiser[0].item_id;
  }
  
  onSelectAllAdvertiser(items: any) {}

  onItemDeSelectType(items: any) {
    this.blackListOffer.advertiserId = 0;
  }
}
